import axios from 'axios';
import { buildUrl, to } from './index.js';
export function createApi(baseURL, token) {
    let derivedToken = typeof token === 'function' ? token() : token;
    const instance = axios.create({
        baseURL,
        headers: derivedToken ? { Authorization: 'Bearer ' + derivedToken } : {},
        withCredentials: true,
    });
    instance.interceptors.response.use((response) => (!response.data.ok ? Promise.reject(response.data) : response.data), (error) => Promise.reject(error.response?.data));
    const api = async (routes, route, options) => {
        // Update the token if it's a function
        if (typeof token === 'function')
            derivedToken = token();
        const routeOptions = routes[route];
        const method = routeOptions.method;
        const qs = options.q;
        const data = options.data;
        const url = buildUrl(routeOptions.path, options.params);
        const requestOverrides = options.requestOverrides;
        return await to(instance.request({
            method,
            url,
            params: { q: JSON.stringify(qs) },
            data,
            ...requestOverrides,
        }));
    };
    // Add the unwrap method
    api.unwrap = async (routes, route, options) => {
        const [err, data] = await api(routes, route, options);
        if (err)
            throw err || new Error('Unknown error occurred');
        return data?.data;
    };
    return api;
}
//# sourceMappingURL=create-api.js.map